import React from 'react';

interface Props {
  className?: string;
  onClick?: React.MouseEventHandler<SVGSVGElement>;
}

const ProfileAddIcon: React.FC<Props> = ({ onClick, className }) => (
  <svg className={className} onClick={onClick} width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M18.5 20.25H14.5C14.09 20.25 13.75 19.91 13.75 19.5C13.75 19.09 14.09 18.75 14.5 18.75H18.5C18.91 18.75 19.25 19.09 19.25 19.5C19.25 19.91 18.91 20.25 18.5 20.25Z"
      fill="white"
    />
    <path
      d="M16.5 22.25C16.09 22.25 15.75 21.91 15.75 21.5V17.5C15.75 17.09 16.09 16.75 16.5 16.75C16.91 16.75 17.25 17.09 17.25 17.5V21.5C17.25 21.91 16.91 22.25 16.5 22.25Z"
      fill="white"
    />
    <path
      d="M12.1597 11.62C12.1297 11.62 12.1097 11.62 12.0797 11.62C12.0297 11.61 11.9597 11.61 11.8997 11.62C8.99971 11.53 6.80971 9.25 6.80971 6.44C6.79971 5.06 7.33971 3.76 8.31971 2.78C9.29971 1.8 10.5997 1.25 11.9897 1.25C14.8497 1.25 17.1797 3.58 17.1797 6.44C17.1797 9.25 14.9897 11.52 12.1897 11.62C12.1797 11.62 12.1697 11.62 12.1597 11.62ZM11.9897 2.75C10.9997 2.75 10.0797 3.14 9.37971 3.83C8.68971 4.53 8.30971 5.45 8.30971 6.43C8.30971 8.43 9.86971 10.05 11.8597 10.11C11.9197 10.1 12.0497 10.1 12.1797 10.11C14.1497 10.02 15.6797 8.41 15.6797 6.43C15.6797 4.41 14.0197 2.75 11.9897 2.75Z"
      fill="white"
    />
    <path
      d="M11.9902 22.5597C9.95016 22.5597 8.02016 22.0297 6.56016 21.0497C5.17016 20.1197 4.41016 18.8497 4.41016 17.4797C4.41016 16.1097 5.18016 14.8497 6.56016 13.9297C9.55016 11.9297 14.4102 11.9297 17.4002 13.9297C17.7402 14.1597 17.8402 14.6297 17.6102 14.9697C17.3802 15.3197 16.9102 15.4097 16.5702 15.1797C14.0802 13.5197 9.88016 13.5197 7.39016 15.1797C6.43016 15.8197 5.91016 16.6297 5.91016 17.4797C5.91016 18.3297 6.43016 19.1597 7.39016 19.7997C8.60016 20.6097 10.2302 21.0497 11.9802 21.0497C12.3902 21.0497 12.7302 21.3897 12.7302 21.7997C12.7302 22.2097 12.4002 22.5597 11.9902 22.5597Z"
      fill="white"
    />
  </svg>
);

export default ProfileAddIcon;
